export default __webpack_public_path__ + "static/char-t-20-ja-2d1b0370f2b1ff681577070eb8951ee3.png";